import { Container } from "reactstrap";
import React from "react";
import { Box, Button } from "@mui/material";
import RenderFormNew from "../../Components/Esaedro/RenderForm/RenderFormNew";
import { useSelector } from "react-redux";
import { RootState } from "../../BusinessObjects/Redux/app/store";
import { Form } from "../../Models/SysConf/Form";
import { useQuery } from "react-query";
import { ResourceNames } from "../../Utils/ResourceNames";
import cubeApiClient from "../../BusinessObjects/cubeApiService";
import { RoutePath } from "../../Utils/RoutePath";
import { NavLink } from "react-router-dom";
import notify from "devextreme/ui/notify";
import Loader from "../../Utils/Loader";

type Props = {};

const ResourceViewPageNew = (props: Props) => {
  // Redux
  const tokenApi = useSelector((state: RootState) => state.user.tokenAPI);
  const userProfile = useSelector((state: RootState) => state.user.userProfile);
  const isLoggedIn = useSelector((state: RootState) => state.user.isLoggedIn);

  // hooks
  const [myObj, setMyObj] = React.useState<any>({});

  // Chiamate Api
  const { data: form, isLoading: isLoadingForm } = useQuery(
    ["form", ResourceNames.ResourcesViewes, userProfile?.customer_ID, tokenApi],
    () => {
      const service = new cubeApiClient();

      return service
        .getItems(
          `api/sys/${ResourceNames.Resources}?RecordSelection=ResourceName='${ResourceNames.ResourcesViewes}'`,
          tokenApi
        )
        .then(
          (data: any) => {
            let urlForm = `api/sys/${ResourceNames.Forms}/query?ResourceId=${data[0].Resource_ID}`;

            return service.getItems(urlForm, tokenApi).then(
              (data: any) => {
                return data[0];
              },
              (error: any) => {
                return undefined;
              }
            );
          },
          (error: any) => {
            return undefined;
          }
        );
    },
    {
      enabled: isLoggedIn,
      refetchOnWindowFocus: false,
      retry: 0,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchIntervalInBackground: false,
    }
  );

  const {
    data: resourcesViews,
    isLoading,
    error,
    refetch,
    isRefetching,
  } = useQuery(
    ["resourcesViews", tokenApi],
    () => {
      const service = new cubeApiClient();

      return service.getItems(
        `api/sys/${ResourceNames.ResourcesViewes}`,
        tokenApi
      );
    },
    {
      enabled: isLoggedIn,
      refetchInterval: false,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchIntervalInBackground: false,
    }
  );

  const formResourceView: Form | undefined = React.useMemo(() => {
    if (form) {
      return form;
    }
    return undefined;
  }, [form]);

  const saveNewResourceView = () => {
    const service = new cubeApiClient();

    myObj.flg_isdeleted = 0;

    service
      .updateObject(myObj, `api/sys/${ResourceNames.ResourcesViewes}`, tokenApi)
      .then(
        (data) => {
          refetch();
          notify("Salvataggio filtro avvenuto con successo", "success", 2000);
        },
        (error) => {
          refetch();
          notify("Errore durante il salvataggio del filtro", "error", 2000);
        }
      );
  };

  // ! Render
  return (
    <>
      {formResourceView === undefined || formResourceView === null ? (
        <Loader />
      ) : (
        <Container>
          <Box
            sx={{
              width: "100%",
              height: "100%",
              justifyContent: "space-around",
              alignItems: "center",
              mt: 1,
              flexDirection: "row",
              mb: 3,
            }}
          >
            <React.Fragment>
              <RenderFormNew
                isNew={true}
                form={formResourceView}
                myObj={myObj}
                saveNewObject={(e) => {
                  setMyObj(e);
                }}
              />
            </React.Fragment>
            <Container>
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  mt: 1,
                  flexDirection: "row",
                }}
              >
                <NavLink to={RoutePath.RESOURCES_VIEWS}>
                  <Button variant="contained" color="error" sx={{ mr: 1 }}>
                    Annulla
                  </Button>
                </NavLink>
                <NavLink to={RoutePath.RESOURCES_VIEWS}>
                  <Button
                    variant="contained"
                    color="success"
                    sx={{ mr: 1 }}
                    onClick={() => {
                      saveNewResourceView();
                    }}
                  >
                    Salva
                  </Button>
                </NavLink>
              </Box>
            </Container>
          </Box>
        </Container>
      )}
    </>
  );
};

export default ResourceViewPageNew;
